<template>
  <div class="common-page-wrap">
    <div v-if="loading" class="common-loading-mask">
      <div class="common-loading-spinner">
        <i class="el-icon-loading" style="font-size:40px;color:var(--brand-primary);"></i>
        <p style="margin-top:16px;color:#909399;">正在加载，请稍候...</p>
      </div>
    </div>
    <router-view></router-view>
    <div class="common_nav" v-show="!loading">
      <el-select v-model="modelValue" @change="changeProject" placeholder="请选择">
        <el-option v-for="item in projectArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
  import {
    getCompangModules,
    permission,
  } from '@/api/user'
  import { localRead, localRemove, localSave } from '@/utils/tools'
  import { addSysRouter } from '@/router/permission'

  export default {
    data() {
      return {
        projectArr: [], //项目集合
        modelValue: '',
        loading: false,
      }
    },
    created() {
      this.getCurrentModel()
    },
    methods: {
      getCurrentModel() {
        let routerLabel, userId
        routerLabel = this.$route.query.label
        try {
          userId = JSON.parse(localRead('userId'))
        } catch (e) {
          return
        }
        // 无 label 时显示蒙层（首次登录选择项目流程），有 label 时不显示
        if (!routerLabel) {
          this.loading = true
        }
        getCompangModules(userId).then(res => {
          this.projectArr = res.result
          localSave('sysCode', JSON.stringify(this.projectArr))
          // 无 label 时选中第一个业务，走完整认证流程（蒙层保持加载中）
          if (!routerLabel && this.projectArr.length > 0) {
            this.modelValue = this.projectArr[0].id
            this.changeProject(this.projectArr[0].id)
            return
          }
          // 有 label 时隐藏蒙层，显示业务选择
          if (!routerLabel) {
            this.loading = false
          }
          this.projectArr.filter(item => {
            if (item.code == routerLabel) {
              this.modelValue = item.id
            }
          })
        }).catch(() => {
          this.loading = false
        })
      },
      changeMenu(routerLabel) {
        permission(1).then(res => {
          const { result } = res
          let getRouter = result
          localSave(routerLabel + '_router', JSON.stringify(getRouter))
          addSysRouter(getRouter, routerLabel)
          this.loading = false
          this.$router.push({ path: '/business/dashboard/list', query: { label: routerLabel } })
          const { name } = this.$route
          if (name) {
            this.$store.dispatch('tagsView/delAllViews', this.$route)
          }
        }).catch(() => {
          this.loading = false
        })
      },
      changeProject(val) {
        let newRouterLabel //切换新系统的标识
        for (let i in this.projectArr) {
          if (this.projectArr[i].id == val) {
            newRouterLabel = this.projectArr[i].code
          }
        }
        this.$store
          .dispatch('user/changeSysterm', val)
          .then(() => {
            let routerLabel = this.$route.query.label
            //项目切换之后清除之前项目的session
            localRemove(routerLabel + '_sys_userInfo')
            localRemove(routerLabel + '_router')
            localRemove(routerLabel + '_admin_token')
            localRemove(routerLabel + '_menus')
            localRemove(routerLabel + '_buttons')
            window.SITE_CONFIG['routerLabel'] = newRouterLabel
            //调菜单获取菜单添加路由
            this.changeMenu(newRouterLabel)
            //存储按钮权限
            this.saveButtonControls()
          })
          .catch(() => {
            //表示没有切换成功 还是原来的值
            this.loading = false
            let label = this.$route.query.label
            this.projectArr.map(item => {
            if (label == item.code) {
              this.modelValue = item.id
            }
          })
          })
      },
      saveButtonControls() {
        permission(2).then(response => {
          const { result } = response
          let buttonsControl = result
          localSave(
            window.SITE_CONFIG['routerLabel'] + '_buttons',
            JSON.stringify(buttonsControl)
          )
        })
      }
    }
  }
</script>

<style lang="scss">
  .common-page-wrap { min-height: 100vh; position: relative; }
  .common-loading-mask {
    position: fixed; inset: 0; z-index: 9999;
    background: rgba(255,255,255,0.85);
    display: flex; align-items: center; justify-content: center;
  }
  .common-loading-spinner { text-align: center; }
  .common_nav {
    position: absolute;
    top: 2px;
    right: 0;
    padding: 5px 5px;
    color: #333;

    .right_serve {
      width: 200px;
      height: 100%;
    }
  }
</style>
